import React from 'react'

import { Search } from 'lucide-react'

import { cn } from 'utils/utils'

import { Input } from '@harvey-frontend/components/ui/input'

interface SearchFilterProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
  value,
  onChange,
  placeholder = 'Search rules',
}) => {
  return (
    <div className="mb-2 flex w-full items-center gap-2">
      <div className="absolute flex items-center px-3">
        <Search
          size={16}
          className={cn('justify-between', {
            'text-muted': value.trim().length === 0,
          })}
        />
      </div>
      <Input
        aria-label="Search filter"
        className="h-8 border-none bg-secondary-hover pl-9 placeholder:text-inactive"
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={(e) => {
          const newValue = e.target.value
          if (value !== newValue) {
            onChange(newValue)
          }
        }}
      />
    </div>
  )
}

export default SearchFilter
